import TagManager from 'react-gtm-module';

export const loadGoogleTagManager = () => {
	TagManager.initialize({
		gtmId: window.ENV.GTM_ID as string,
	});
};
